import { render } from "./News3.vue?vue&type=template&id=75333c64"
import script from "./News3.vue?vue&type=script&lang=js"
export * from "./News3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__